import { ProjectEditRouteView } from './view';
import { withCrumb } from '@/app/routing/breadcrumbs';

export const editRoute = {
  path: 'edit',
  element: <ProjectEditRouteView/>,
  handle: () => withCrumb({
    element: () => <span>Edit</span>,
  }),
};